// extracted by mini-css-extract-plugin
module.exports = {"entries":"ViewEntries_entries__3beVR","viewAllSubmissions":"ViewEntries_viewAllSubmissions__1-UIH"};